<template>
  <div>
    <Modal
      v-model="resourceVisible"
      :title="mysearchData.title"
      width="1000px;"
      :mask-closable="false"
    >
      <Form
        :model="mysearchData"
        inline
        :label-width="60"
        ref="searchForm"
        :rules="rules"
      >
        <div style="display:flex">
          <div v-for="(item, index) in addResourceList" :key="index">
            <FormItem :label="item.name" :prop="item.prop">
              <Select
                v-model="mysearchData[item.prop]"
                multiple
                v-if="item.type == 'select' && item.prop == 'accountIds'"
                @on-change="item.change(item, mysearchData[item.prop])"
                style="width:150px"
              >
                <Option v-for="s in accountList" :value="s.id" :key="s.id">{{
                  s.name
                }}</Option>
              </Select>
              <Select
                v-model="mysearchData[item.prop]"
                v-if="item.type == 'select' && item.prop == 'region'"
                @on-open-change="getRegion"
                @on-change="item.change(item, mysearchData[item.prop])"
                style="width:150px"
              >
                <Option
                  v-for="s in regionList"
                  :value="s.key || s.name"
                  :key="s.key"
                  >{{ s.name }}</Option
                >
              </Select>
              <!-- <Input
                v-model="mysearchData[item.prop]"
                v-if="item.type == 'input'"
                style="width:150px"
                @on-search="item.change && item.change(item.prop)"
              ></Input> -->
              <Button
                v-if="item.type == 'button'"
                type="primary"
                style="margin-left:0"
                @click="item.handle(item, mysearchData[item.prop])"
                >{{ item.btnName }}</Button
              >
            </FormItem>
          </div>
        </div>
      </Form>

      <Table
        :columns="addColums"
        :data="addTableData"
        :height="400"
        style="margin-bottom:10px"
        @on-select="handleChangeSelection"
        @on-select-all="handleChangeAllSelection"
        @on-select-cancel="handleChangeSelectSelection"
        @on-select-all-cancel="handleChangeCancelSelectSelection"
      >
      </Table>
      <div slot="footer">
        <Button @click="cancel('resourceForm')">{{
          $t("permission_configuration_management.common.cancel")
        }}</Button>
        <Button type="primary" @click="handleSubmit('resourceForm')">{{
          $t("permission_configuration_management.common.confirm")
        }}</Button>
      </div>
    </Modal>
  </div>
</template>

<script>
export default {
  props: {
    addResourceData: {
      type: Object,
      default: () => {}
    },
    addResourceList: {
      type: Array,
      default: () => []
    },
    addColums: {
      type: Array,
      default: () => []
    },
    addTableData: {
      type: Array,
      default: () => []
    },
    rules: {
      type: Object,
      default: () => {}
    },
    getAccountType: {
      type: Number,
      default: 0
    },
    getAccountId: {}
  },
  watch: {},
  data() {
    return {
      mysearchData: this.addResourceData,
      resourceVisible: false,
      accountList: [],
      regionList: [],
      bucketDTOS: []
    };
  },
  methods: {
    handleSubmit(rule) {
      this.$emit("submit", rule, this.bucketDTOS);
    },
    cancel() {
      this.resourceVisible = false;
    },
    // 账户下拉框
    getAccount() {
      this.$api.groupAccountRelation
        .getAccountByGroupIdAndCloudPlatform({
          groupId: this.$route.query.id,
          accountType: this.getAccountType
        })
        .then(res => {
          this.accountList = res.data;
        });
    },
    handleChangeAccount(item, value) {
      this.$api.account
        .queryAccountRegionsByAccountIds("accountIds", value)
        .then(res => {
          this.regionList = res.data;
        });
    },
    getRegion() {
      this.$api.account
        .queryAccountRegionsByAccountIds("accountIds", this.getAccountId)
        .then(res => {
          this.regionList = res.data;
        });
    },
    handleChangeSelection(selection) {
      this.bucketDTOS = selection;
    },
    handleChangeAllSelection(selection) {
      this.bucketDTOS = selection;
    },
    handleChangeSelectSelection(selection) {
      this.bucketDTOS = selection;
    },
    handleChangeCancelSelectSelection(selection) {
      this.bucketDTOS = selection;
    }
  }
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/components/configuration/permissions_configuration_management/resource_permission/resource/AddResource.vue